export default {"src":"/_next/static/media/vault-loading.f0dbbda8.gif","height":134,"width":134,"blurWidth":0,"blurHeight":0};